export const REFERRAL_SOURCE_OPTIONS = [
  'Google Search',
  'Attorney',
  'Probation Officer',
  'Radio Advertisement',
  'Flyer',
  'Website',
  'Social Media',
  'Facebook',
  'Instagram',
  'TikTok',
  'YouTube',
  'Friend / Family',
  'Previous Student',
  'Court',
  'Employer',
  'School',
  'Community Event',
  'Walk-In',
  'Returning Student',
  'Other'
];

export function referralSourceOptionsFor(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed || REFERRAL_SOURCE_OPTIONS.includes(trimmed)) {
    return REFERRAL_SOURCE_OPTIONS;
  }
  return [trimmed, ...REFERRAL_SOURCE_OPTIONS];
}
